import * as React from "react";
const SvgFiRrRazorBarber = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-razor-barber_svg__a)">
      <path
        fill="#062147"
        d="M23.333.057a1 1 0 0 0-1.276.61A2 2 0 0 1 20.17 2H4.073a4.005 4.005 0 0 0-3.97 3.511l-.084.684A2.503 2.503 0 0 0 2.499 9h9.25a4 4 0 0 0 3.973-3.542L15.89 4h2.09c-.206 3.696-2.629 9.671-6.972 14.042a3.506 3.506 0 0 0 .034 4.95A3.5 3.5 0 0 0 13.499 24c.904 0 1.808-.347 2.492-1.039 5.654-5.727 5.58-17.143 5.52-19.199a4 4 0 0 0 2.432-2.427 1 1 0 0 0-.61-1.277M13.736 5.23A2 2 0 0 1 11.748 7H2.5a.5.5 0 0 1-.497-.56l.084-.685C2.21 4.755 3.064 4 4.072 4h9.805l-.143 1.23zm.832 16.325a1.5 1.5 0 0 1-2.123.014 1.503 1.503 0 0 1-.015-2.12c3.605-3.628 5.964-8.208 6.986-12.029-.282 4.126-1.31 10.55-4.848 14.134z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-razor-barber_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRazorBarber;
